import { defineEntity, custom, ephemeral } from './_helpers.js';

export default defineEntity(
    'auth',
    {
        login:               custom({ scope: 'security' }),
        loginFailed:         custom({ scope: 'security' }),
        ssoDenied:           custom({ scope: 'security' }),
        logout:              ephemeral(),
        sessionExpired:      ephemeral(),
        tokenRefreshed:      ephemeral(),
        suspiciousActivity:  custom({ scope: 'security' }),
    },
    { includeDefaultLifecycle: false },
);
